import './init/log.js';
import log from 'loglevel';
import API from './api/API.js';
import { EVENT, KV } from './common/Constant.js';
import Store from './common/Store';
import Interface from './Interface.js';
import { checkDevice } from './utils/utils.js';

class VhallUpload {
  // 版本号
  static get VERSION() {
    return process.env.VERSION;
  }

  // 事件
  static get EVENT() {
    return EVENT;
  }

  // 创建sdk实例
  static async createInstance(opt = {}, success = () => {}, failure = () => {}) {
    log.info(' createInstance init');
    const { appId, accountId, token, attributeId } = opt;
    const client = opt.client || checkDevice();
    const store = new Store();
    store.setKV(KV.APP_ID, appId);
    store.setKV(KV.THIRD_PARTY_USER_ID, accountId);
    store.setKV(KV.ACCESS_TOKEN, token);
    store.setKV(KV.CLIENT, client);
    store.setKV(KV.PACKAGE_CHECK, 'peter');
    store.setKV(KV.ATTRIBUTE_ID, attributeId);
    this.api = new API(store);

    try {
      const _interface = { interface: new Interface(this.api, store) };
      success(_interface);
      return _interface;
    } catch (error) {
      if (failure) return failure(error);
      throw error;
    }
  }
}

window.VhallUpload = VhallUpload;
export default VhallUpload;
